import sagaReducerFactory from 'saga-reducer-factory';
import organizationActions from '../actions/organizationActions';
import {put, call} from 'redux-saga/effects';

const {handle, updateState, saga, reducer} = sagaReducerFactory({
  actionTypes: organizationActions.types,
  actionCreators: organizationActions.actions,
  initState: {organization: {}, pending: false, error: null}
});

handle(organizationActions.types.GET_ORGANIZATION_REQUEST, function* ({restClient}, action) {
  yield put(updateState({pending: true}));

  try {
    const organizationId = action.payload;

    const organization = yield call(restClient, `/organizations/${organizationId}`);
    yield put(updateState({organization, pending: false, error: null}));
    yield put(organizationActions.actions.getOrganizationSuccess(organization));
  } catch (error) {
    yield put(organizationActions.actions.getOrganizationFailure(error));
  }
});

export default {saga, reducer};



// WEBPACK FOOTER //
// ./sagas/organizationSaga.js